import { FCC, IdentifierDTO } from '@zazume/zzm-base';

import { Can } from '#/components/roles/Can';
import { ManagementService } from '#/domain/ownerServiceContract/ManagementService';
import { OwnerServiceContract } from '#/domain/ownerServiceContract/OwnerServiceContract';
import { useGet } from '#/hooks';
import { OwnerServiceContractKeys } from '#/hooks/api/ownerServiceContract.keys';
import { UnitKeys } from '#/hooks/api/units/UnitKeys';
import { API } from '#/lib/network/API';
import { Unit } from '#/models';

interface CanPropertyManagementCallsProps {
  ownerAccountId: IdentifierDTO;
}

export const CanPropertyManagementCalls: FCC<CanPropertyManagementCallsProps> = ({ ownerAccountId, children }) => {
  const { data: activeOwnerServiceContracts = [], isLoading } = useGet<OwnerServiceContract<ManagementService>[]>(
    OwnerServiceContractKeys.findAllActiveByOwnerAccountId(ownerAccountId),
    API.ownerServiceContract.management.findAllActiveByOwnerAccountId(ownerAccountId)
  );

  if (isLoading || activeOwnerServiceContracts.length === 0) {
    return null;
  }

  return (
    <>
      <Can hasRoles={['ownerManager', 'ownerMiddle', 'ownerBasic']}>{children}</Can>
    </>
  );
};
